<template>
  <div>
    <!--    기본정보-->
    <field-select-module v-model="form.stdInfo" :options="[
        { type: 'date', label: '점검일'},
        { type: 'text', label: '점검장소'},
        { type: 'disaster', label: '재해형태'}
      ]" :board="this.board" :is-print="isPrint"/>

    <!--    장비정보-->
    <table-equipment
      class="mt-5"
      :list="form.equipmentList"
      @updateList="updateList"
      :isPrint="isPrint"
      :isReadonly="board.readonly"
    ></table-equipment>


    <!--    점검대상-->
<!--    <vs-row class="mt-6">-->
<!--      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">-->
<!--        <h5>-->
<!--          <i class="dot"></i> 점검대상-->
<!--        </h5>-->
<!--      </vs-col>-->
<!--    </vs-row>-->

<!--    <div class="gap-x-6 gap-y-4 mt-4">-->
<!--      <span v-if="isPrint"> {{form.inspectionTitle}} </span>-->
<!--      <div class="ml-group-checkBox flex flex-wrap w-full flex-1" v-else>-->
<!--        <vs-checkbox-->
<!--          class="mr-1 mb-2"-->
<!--          :readonly="board.readonly">-->
<!--          {{form.inspectionTitle}}-->
<!--        </vs-checkbox>-->
<!--      </div>-->
<!--    </div>-->


    <!--    전기작업-->
    <table-inspect
      class="mt-5"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      :is-show-title="true"
      :title="form.inspectionTitle"
      :list="form.inspectList"
      @update-list-check="updateListCheck"
    />


    <!--    사진대지-->
    <PhotoUploadGridModule
      :row-count="2"
      :grid-count="2"
      v-model="form.photoList"
      :is-print="isPrint"
      :readonly="board.readonly"
      section-title="사진대지"
      placeholder="신축현장 점검"
    />

    <!--    파일첨부-->
    <file-upload-module
      id="fileList"
      class="w-full mt-4"
      v-model="form.fileList"
      :is-print="isPrint"
      :readonly="board.readonly"
    ></file-upload-module>

  </div>
</template>

<script>
import PopupPlanProject from '@/views/project/popup/PopupPlanProject'
import DateSelector from '@/components/selector/DateSelector'
import PopupProjectSetting from '@/views/project/PopupProjectSetting'
import MemberSelector from '@/components/selector/MemberSelector'
import CompanySelector from '@/components/selector/CompanySelector'
import FileUploader from '@/components/FileUploader'
import FileUploadModule from '@/views/modules/FileUploadModule'
import TableInspect from '@/components/TableInspect'
import TableEquipment from '@/components/TableEquipment'
import DisasterClassSelector from '@/components/selector/DisasterClassSelector'
import FieldSelectModule from '@/views/modules/FieldSelectModule'
import PhotoUploadGridModule from '@/views/modules/PhotoUploadGridModule'

export default {
  components: {
    FileUploadModule,
    TableInspect,
    TableEquipment,
    DisasterClassSelector,
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject,
    FieldSelectModule,
    PhotoUploadGridModule
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler (value) {
        const keys = Object.keys(this.form)
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key]
          }
        }

        this.form.inspectionTitle = this.inspectionTitle
        if (!this.form || !this.form.inspectList || this.form.inspectList.length === 0) {
          this.form.inspectList = this.inspectTable
        }
      }
    },
    form: {
      immediate: true,
      deep: true,
      handler (value) {

        value.summary = {
          안전보건점검_사업장명: [],
          안전보건점검_점검표: []
        }

        value.summary['안전보건점검_사업장명'].push({
          [this.form.stdInfo.field_name]: 1
        })

        value.summary['안전보건점검_점검표'].push({
          [this.form.inspectionTitle.trim()]: 1
        })

        this.$emit('input', value)
      }
    }
  },
  data () {
    return {
      inspectionTitle: '전기작업',
      form: {
        inspectionTitle: '전기작업',
        stdInfo: { },
        photoList: [],
        fileList: [],
        equipmentList: [],
        inspectList: []
      },
    }
  },
  computed: {
    inspectTable () {
      return [
        {
          id: 1,
          label: '작업 전로 차단, 잠금장치 및 꼬리표(LOTO) 부착하고 검전기를 이용하여 충전여부를 확인하고 있다.',
          is_checked: ''
        },
        {
          id: 2,
          label: '전기기구 취급작업 시 전기설비로부터 폭 70cm 이상의 작업공간을 확보하고 있다.',
          is_checked: ''
        },
        {
          id: 3,
          label: '감전위험이 있는 전기기계·기구 또는 전로의 설치·해체·정비·점검(설비의 유효성을 장비, 도구를 이용하여 확인하는 점검) 등의 작업을 하는 경우에 유자격자가 작업을 수행하고 있다.',
          is_checked: ''
        },
        {
          id: 4,
          label: '전기기계·기구 및 설비의 전원 접속부인 충전부가 노출되어 있지 않다.',
          is_checked: ''
        },
        {
          id: 5,
          label: '전기기계·기구 및 설비의 금속재, 철재 등의 외함에 접지시설이 되어있다.',
          is_checked: ''
        },
        {
          id: 6,
          label: '휴대형 또는 이동형 전동기계의 전원에 누전차단기가 설치되어 있다.',
          is_checked: ''
        },
        {
          id: 7,
          label: '전기기기 외함에 접지된 접지선이 접지극과 직접 연결되어 있다.(접지 연속성 유무)',
          is_checked: ''
        },
        {
          id: 8,
          label: '누전여부 체크를 위해 주기적으로 절연저항을 측정하고 기록한다.',
          is_checked: ''
        },
        {
          id: 9,
          label: '주기적으로 접지저항을 측정하고, 접지 저항값이 기준에 적합하다.',
          is_checked: ''
        },
        {
          id: 10,
          label: '용접선, 배선, 이동전선 등 절연전선의 피복이 손상되어 있지 않다.',
          is_checked: ''
        },
        {
          id: 11,
          label: '정전작업 중 타 작업자의 개폐기 오조작 방지를 위하여 분전반 또는 개폐기에 잠금장치나 표지판을 설치하였다.',
          is_checked: ''
        },
        {
          id: 12,
          label: '변전실 출입문에 잠금장치를 하고, 관계자외 출입금지 표시를 부착하였다.',
          is_checked: ''
        },
        {
          id: 13,
          label: '변전실 등 특별고압 충전전로에 접근한계거리 표지판이 부착되어 있다.',
          is_checked: ''
        },
        {
          id: 14,
          label: '근접장소에서의 청소 등의 작업 시 접근한계거리를 유지하여 작업하도록 관리한다.',
          is_checked: ''
        },
        {
          id: 15,
          label: '낙뢰위험지역에 낙뢰에 의한 위험방지를 위해 피뢰침을 설치하였다. ',
          is_checked: ''
        },
        {
          id: 16,
          label: '피뢰침의 접지 저항치를 측정하여 적정한 수준을 유지한다.',
          is_checked: ''
        },
        {
          id: 17,
          label: '물 등의 도전성이 높은 액체가 있는 습윤한 장소에서의 이동전선 등은 충분한 절연효과가 있다.',
          is_checked: ''
        },
        {
          id: 18,
          label: '정전기에 의한 화재, 폭발 등의 위험이 발생할 우려가 있는 경우 해당설비에 대하여 확실한 방법으로 접지, 도전성 재료 사용, 제전장치 등 정전기 제거 조치를 하였다.',
          is_checked: ''
        },
        {
          id: 19,
          label: '전기기계·기구 또는 전로의 설치·해체·정비·점검 등의 전기작업(50V초과 또는 전기에너지가 250VA를 넘는 경우)시 작업계획서를 작성하고 그 계획에 따라 작업을 하였다.',
          is_checked: ''
        },
        {
          id: 20,
          label: '충전전로 등의 전기 작업을 할 때에는 절연용 보호구, 절연용 방호구 등을 근로자에게 지급·착용토록 한다.',
          is_checked: ''
        },
      ]
    },
  },
  methods : {
    updateList (list) {
      this.form.equipmentList = list
    },
    updateListCheck (indexRows, text) {
      this.form.inspectList[indexRows].is_checked = text
    },
  }
}
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}
.mt-component-form {
  margin-top: 15px;
}

/* uploaded File */
.h-upload {
  height: 470px;
}
.upload-content {
  border: $border;
  &:last-child {
    border-left: none;
  }
  &__title {
    height: 54px;
    line-height: 54px;
    text-align: center;
    background: #fafafa;
    border-bottom: $border;
  }
  &__input {
    height: 54px;
    background: #f9f9f9;
    border-top: $border;
    padding: 5px 15px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &__file {
    height: calc(100% - 54px);
    width: 100%;
    padding: 14px;
  }
}
</style>
